import { Button, Flex, Skeleton, Typography } from "antd";
import brokenImg2 from "../../../assets/v2/unable-to-retrieve-img.png";
import { useStore } from "../../../context/CreateStoreContext";
import Account from "./Account";
import Information from "./Information";
import Notice from "./Notice";
import style from "./StoreDetails.module.css";
import Subscription from "./Subscription";

const { Title, Paragraph } = Typography;

export default function StoreDetails({ loading, hasError }) {
  return hasError ? (
    <StoreDetailsFaied />
  ) : (
    <Flex vertical gap="30px" className={style.StoreDetails}>
      <Skeleton active loading={loading}>
        <Notice />
        <Information />
      </Skeleton>
      <Skeleton active loading={loading}>
        <Subscription />
      </Skeleton>
      <Skeleton active loading={loading}>
        <Account />
      </Skeleton>
    </Flex>
  );
}

const StoreDetailsFaied = () => (
  <Flex
    vertical
    justify="center"
    align="center"
    style={{ paddingTop: "4.938rem" }}
  >
    <img src={brokenImg2} alt="Failed" width="135px" height="138px" />
    <Title level={2} style={{ color: "#515151" }}>
      Unable to retrieve data
    </Title>
    <Paragraph
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#000000a6",
        maxWidth: "542px",
        marginBottom: "3.125rem",
      }}
    >
      Please refresh the page to try again. If the issue persists, contact
      customer support for assistance.
      <br />
      <br />
      Call us on{" "}
      <a href="tel:8182351327" style={{ color: "#E99E25", fontWeight: "500" }}>
        (818) 235-1327
      </a>{" "}
      or email us at{" "}
      <a
        href="mailto:support@bevz.com"
        style={{ color: "#E99E25", fontWeight: "500" }}
      >
        support@bevz.com
      </a>
    </Paragraph>

    <Button
      className={style.button}
      size="large"
      type="primary"
      onClick={() => window.location.reload()}
    >
      Refresh Page
    </Button>
  </Flex>
);
